import { useState } from 'react';
import useScrollReveal from '@/hooks/useScrollReveal';
import { testimonials } from '@/mocks/testimonials';

const Testimonials = () => {
  const [current, setCurrent] = useState(0);
  const ref = useScrollReveal();

  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section className="bg-cream py-24 px-6">
      <div ref={ref} className="reveal max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-[2px] bg-gold" />
            <span className="font-inter text-gold text-xs font-semibold tracking-[0.25em] uppercase">
              Graduate Outcomes
            </span>
            <div className="w-8 h-[2px] bg-gold" />
          </div>
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-charcoal">
            Real People. Real Outcomes.
          </h2>
          <p className="font-inter text-base text-charcoal/60 mt-4 max-w-lg mx-auto">
            These are the stories that define OST-C&apos;s mission — individuals who came in looking for a path and left with a career.
          </p>
        </div>

        {/* Testimonial card */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg p-10 md:p-14 border border-cream-100 relative overflow-hidden">
            {/* Decorative quote */}
            <span className="absolute top-4 left-6 font-playfair text-[120px] text-gold/8 leading-none select-none font-bold">
              &#8220;
            </span>
            {/* Gold top bar */}
            <div className="absolute top-0 left-0 right-0 h-[3px] bg-gold" />

            <div className="relative">
              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-gold text-base" />
                ))}
              </div>

              {/* Quote */}
              <blockquote className="font-playfair text-xl md:text-2xl text-charcoal leading-relaxed mb-8 italic">
                &ldquo;{t.quote}&rdquo;
              </blockquote>

              {/* Attribution */}
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div>
                  <p className="font-inter font-bold text-charcoal">{t.name}</p>
                  <p className="font-inter text-sm text-charcoal/55">{t.detail}</p>
                </div>
                <div className="bg-gold/10 border border-gold/30 rounded-full px-4 py-1.5">
                  <span className="font-inter text-xs font-bold text-gold">{t.outcome}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Controls */}
          <div className="flex items-center justify-center gap-6 mt-8">
            <button
              onClick={prev}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-charcoal/20 hover:border-gold hover:text-gold text-charcoal transition-all duration-200 cursor-pointer"
              aria-label="Previous testimonial"
            >
              <i className="ri-arrow-left-line" />
            </button>
            <div className="flex gap-2">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`rounded-full transition-all duration-200 cursor-pointer ${
                    i === current ? 'w-6 h-2 bg-gold' : 'w-2 h-2 bg-charcoal/20 hover:bg-gold/50'
                  }`}
                  aria-label={`Go to testimonial ${i + 1}`}
                />
              ))}
            </div>
            <button
              onClick={next}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-charcoal/20 hover:border-gold hover:text-gold text-charcoal transition-all duration-200 cursor-pointer"
              aria-label="Next testimonial"
            >
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
